










































import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";

// Mixins
import RequestPromises from "@/mixins/requestPromises";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Types
import { IState } from "@/store";
import {
  IBlueprintField,
  IProvisionProductFieldValue
} from "@/models/provisioning";
import { IProduct } from "@/models/products";

@Component({
  components: {
    "configure-field-row": () =>
      import(
        "@/components/app/admin/catalogue/products/provisioning/configureFieldRow.vue"
      )
  },
  computed: {
    ...mapState({
      productFieldsScope(state: IState, getters) {
        return getters[`data/${this.provisionDataModule}/productFieldsScope`](
          this.productId
        );
      },
      productFields(state: IState, getters) {
        return getters[`data/listArray`]({
          storeModule: this.provisionDataModule,
          scope: this.productFieldsScope
        });
      },

      productFieldsValuesScope(state: IState, getters) {
        return getters[
          `data/${this.provisionDataModule}/productFieldsValuesScope`
        ](this.productId);
      },
      productFieldsValues(state: IState, getters) {
        return getters[`data/listArray`]({
          storeModule: this.provisionDataModule,
          scope: this.productFieldsValuesScope
        });
      }
    })
  }
})
export default class ConfigureFieldList extends Mixins(RequestPromises) {
  public productFieldsScope!: string;
  public productFields!: IBlueprintField[];

  public productFieldsValuesScope!: string;
  public productFieldsValues!: IProvisionProductFieldValue[];

  @Prop({ required: true })
  public productId!: IProduct["id"];

  @Prop({ default: false })
  public isDisabled!: boolean;

  public guardFunctionalities = [
    "list_product_provision_fields",
    "list_product_provision_field_values",
    "check_product_provision_field_values"
  ];

  public provisionDataModule: DataModules = DataModules.PROVISIONING;

  public isLoading = false;
  public isReloading = false;
  public requestError = false;

  public productFieldsErrors = {};

  public created() {
    if (!this.isContentAvailable) {
      return;
    }

    this.isLoading = true;
    this.loadData();
  }

  public async loadData() {
    try {
      await Promise.all([
        this.getProductFields(),
        this.getProductFieldsValues(),
        this.checkConfiguration()
      ]);
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.requestError = true;
    }
    this.isLoading = false;
    this.isReloading = false;
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public getProductFields(ignoreStored = false) {
    return this.$store.dispatch(
      `data/${this.provisionDataModule}/listProductFields`,
      {
        id: this.productId,
        scope: this.productFieldsScope,
        vm: this,
        params: {
          order: "order",
          limit: 0
        },
        ignoreStored
      }
    );
  }

  public getProductFieldsValues(ignoreStored = false) {
    return this.$store.dispatch(
      `data/${this.provisionDataModule}/listProductFieldsValues`,
      {
        id: this.productId,
        scope: this.productFieldsValuesScope,
        vm: this,
        params: {
          limit: 0
        },
        ignoreStored
      }
    );
  }

  public checkConfiguration() {
    return new Promise((resolve, reject) => {
      this.checkProductFieldsConfiguration()
        .then(() => {
          this.productFieldsErrors = {};
          resolve(true);
        })
        .catch(error => {
          const errorData = this.$_.get(error, "response.data.error");

          if (errorData.code !== 409) {
            reject(error);
          }

          this.productFieldsErrors = errorData.data;
          resolve(true);
        });
    });
  }

  public checkProductFieldsConfiguration() {
    return this.$store.dispatch(
      `data/${this.provisionDataModule}/checkProductFieldsValues`,
      {
        id: this.productId
      }
    );
  }

  public async configureField(field) {
    if (this.isDisabled) return;
    const result = await this.$store.dispatch(
      `data/${this.provisionDataModule}/openManageProvisionFieldModal`,
      {
        field: this.$_.find(this.productFields, ["id", field.id]),
        fieldValues: this.productFieldsValues,
        fieldError: this.findProductFieldError(field.name),
        productId: this.productId
      }
    );

    if (this.$_.get(result, "cancelled", true)) {
      return;
    }

    try {
      this.isLoading = true;
      await Promise.all([
        this.getProductFieldsValues(true),
        this.checkConfiguration()
      ]);
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.requestError = true;
    }
    this.isLoading = false;
  }

  public findProductFieldError(fieldName: string) {
    return this.$_.get(
      this.$_.get(
        this.productFieldsErrors,
        `configurations.provision_field_values.${fieldName}`,
        []
      ),
      "[0]",
      false
    );
  }

  public get isContentAvailable() {
    return this.$userCan(...this.guardFunctionalities);
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binList", {
      storeModule: this.provisionDataModule,
      scope: this.productFieldsScope,
      vm: this
    });

    this.$store.dispatch("data/binList", {
      storeModule: this.provisionDataModule,
      scope: this.productFieldsValuesScope,
      vm: this
    });
  }
}
